var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWarningYellow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "14px",
    viewBox: "0 0 16 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "v3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LV---Vika-(Drag)",
    transform: "translate(-575.000000, -208.000000)",
    fill: "#F5A623",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconmonstr-warning-7-(4)",
    transform: "translate(575.000000, 208.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.63636364,0 L0,14 L15.2727273,14 L7.63636364,0 Z M7,5.09090909 L8.27272727,5.09090909 L8.27272727,9.54545455 L7,9.54545455 L7,5.09090909 Z M7.63636364,12.25 C7.19727273,12.25 6.84090909,11.8936364 6.84090909,11.4545455 C6.84090909,11.0154545 7.19727273,10.6590909 7.63636364,10.6590909 C8.07545455,10.6590909 8.43181818,11.0154545 8.43181818,11.4545455 C8.43181818,11.8936364 8.07545455,12.25 7.63636364,12.25 Z",
    id: "Shape"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarningYellow);
export default __webpack_public_path__ + "static/media/icon-warning-yellow.eadbc8635a300cc47b91d1c5ad98ec7a.svg";
export { ForwardRef as ReactComponent };